import React, { useContext } from 'react';
import { Icon } from 'components';
import styles from 'styles/sidebar.module.scss';
import {
	faChartLine,
	faBullhorn,
	faCog,
	faCartPlus,
	faQuestionCircle,
	faThumbtack,
	faLightbulb,
	faUsers
} from '@fortawesome/fontawesome-pro-solid';
import { Reviewing } from 'components'
import UserContext from 'context/UserContext';
import ShopContext from 'context/ShopContext';
import useReactRouter from 'use-react-router';
import SidebarContext from 'context/SidebarContext';
import { USER_SHIELD_ICON, SACK_DOLLAR_ICON, COMMENT_DOLLAR } from 'lib/globals';
import Logo from "svgs/logo_v2.png"

const SideBar = () => {
	const { collapsed, setCollapsed } = useContext(SidebarContext);
	const user = useContext(UserContext);
	const shopContext = useContext(ShopContext)
	return (
		<div className={styles.sidebar} collapsed={collapsed ? 1 : 0}>
			<div className={styles.logo}>
				<img src={Logo} />
			</div>
			<div className={styles.menu}>
				<MenuItem pathto="/" activeRoutes={['/', '/dashboard']} icon={faChartLine}>
					Dashboard
				</MenuItem>
				<MenuItem pathto="/settings" activeRoutes={['/settings']} icon={faCog}>
					Cart Settings
				</MenuItem>
				<MenuItem pathto="/campaigns" activeRoutes={['/campaigns']} icon={faBullhorn}>
					Upsell Campaigns
				</MenuItem>
				<MenuItem pathto="/sticky" activeRoutes={['/sticky']} icon={faCartPlus}>
					Sticky cart
				</MenuItem>
				<div className={styles.spacer}></div>
				<MenuItem icon={COMMENT_DOLLAR} pathto="/affiliation" activeRoutes={['/affiliation']} badge="New">
					Referral Program
				</MenuItem>
				{/* <MenuItem onClick={() => {window.open("https://monsterapps.shop/partner-program/")}}>
					Affiliate Signup
				</MenuItem> */}
				<MenuItem icon={faUsers} onClick={() => { window.open("https://www.facebook.com/groups/ecom.monsterapps") }}>
					Facebook Group
				</MenuItem>
				<MenuItem icon={faLightbulb} onClick={() => { window.open("https://monsterupsells.feedbear.com/boards/feature-requests") }}>
					Feature Suggestion
				</MenuItem>
				<MenuItem pathto="/plan" icon={SACK_DOLLAR_ICON}>
					Your Plan
				</MenuItem>
				<MenuItem icon={faQuestionCircle} onClick={() => { window.open("https://monsterapps.crisp.help/en/category/monsterupsells-48n04z") }}>
					Faq
				</MenuItem>
				<MenuItem icon={USER_SHIELD_ICON} onClick={() => { window.open("https://monsterapps.crisp.help/en/article/privacy-policy-monsterupsells-76n8in") }}>
					Privacy Policy
				</MenuItem>
			</div>
			<div className={styles.attach} active={collapsed ? 0 : 1}>
				<Icon icon={faThumbtack} size="xs" onClick={() => setCollapsed(!collapsed)} />
			</div>
			<div className={styles.widget}>
				<Reviewing {...{ user, shopContext }} />
			</div>
		</div>
	);
};

const MenuItem = ({ pathto, activeRoutes = false, children, icon, onClick, badge }) => {
	const { history, location } = useReactRouter();
	const active = (activeRoutes || [pathto]).includes(location.pathname);
	return (
		<div
			className={styles.menu_item}
			data-active={active}
			pathto={pathto}
			onClick={() => {
				if (onClick) onClick()
				else if (!active) history.push(pathto + location.search);
			}}
		>
			<div>
				<Icon icon={icon} size="lg" />
				<span className={styles.text}>{children}</span>
			</div>
			{
				badge &&
				<SideBarBadge>{badge}</SideBarBadge>
			}
		</div>
	);
};

export const SideBarBadge = ({ children, style, className = '' }) => <div className={`${styles.badge} ${className}`} style={style}>{children}</div>

export default SideBar;
